/* ===================== Snippet & Image Saver ===================== */

// ---- Floating save button for TEXT ----
const saveContainer = document.querySelector('#evergreen-sidebar-snippet-container');
// Prevent the floating snippet container from affecting text selection
if (saveContainer) {
  saveContainer.addEventListener('mousedown', (e) => {
    e.preventDefault();
  });

  saveContainer.addEventListener('mouseup', (e) => {
    e.stopPropagation();
  });

  saveContainer.addEventListener('touchstart', (e) => {
    e.stopPropagation();
  });
}
const saveButton = document.querySelector('#evergreen-sidebar-snippet');
const snippetCopyButton = document.querySelector('#evergreen-sidebar-snippet-copy');
const shareButton = document.querySelector('#evergreen-sidebar-share');
const printButton = document.querySelector('#evergreen-sidebar-print');
const copyButton = document.querySelector('#evergreen-sidebar-copy');
const sidebar = document.querySelector('.evergreen-sidebar-container');
const sidebarToggleButtons = document.querySelectorAll('#sidebar-toggle');
const snippetShareTrigger = saveContainer?.querySelector('.snippet-saver [data-expandable-btn][aria-controls]');
const mainContent = document.querySelector('#main-content');

const SHARE_ACTION_CREATE = 'evergreen_snippet_share_create';
const SHARE_ACTION_GET = 'evergreen_snippet_share_get';
const SHARE_PARAM = (window.fritzScripts && fritzScripts.savedListParam) || 'saved_list';

console.log('[Snippet Saver] Initialized.');

let selectedText = '';
let selectedTextMarkdown = '';
let noticeTimer = null;

// ---------------- Utilities ----------------
function getSaved() {
  try {
    const raw = localStorage.getItem('savedSnippets') || '[]';
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('[Snippet Saver] Could not parse saved snippets, resetting.', error);
    return [];
  }
}

const setSaved = (arr) => localStorage.setItem('savedSnippets', JSON.stringify(arr));
const makeId = () => `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

function updateSavedCount() {
  const count = getSaved().length;

  sidebarToggleButtons.forEach((button) => {
    button.dataset.count = count;

    if (count > 0) {
      button.classList.add('has-count');
    } else {
      button.classList.remove('has-count');
    }
  });
}

function ensureIds() {
  const saved = getSaved();
  let mutated = false;
  for (const s of saved) {
    if (!s.id) {
      s.id = makeId();
      mutated = true;
    }
  }
  if (mutated) setSaved(saved);
}

function toAbsoluteUrl(url) {
  try {
    return new URL(url, window.location.href).href;
  } catch {
    return url;
  }
}

function toSafeHttpUrl(url) {
  if (!url) return '';
  try {
    const parsed = new URL(url, window.location.href);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') {
      return parsed.href;
    }
    return '';
  } catch {
    return '';
  }
}

function getShareableUrlFromElement(el) {
  const group = el?.closest('.button-group');
  const shareable = el?.closest('.evergreen-shareable');
  const raw = (group?.dataset.shareableUrl || shareable?.dataset.shareableUrl || '').trim();
  const safe = toSafeHttpUrl(raw);
  return safe || window.location.href;
}

function getShareableMetaFromElement(el) {
  const group = el?.closest('.button-group');
  const shareable = el?.closest('.evergreen-shareable');
  const type = String(group?.dataset.shareableType || shareable?.dataset.shareableType || '').trim().toLowerCase();
  const title = String(group?.dataset.shareableTitle || shareable?.dataset.shareableTitle || '').trim();
  const image = String(group?.dataset.shareableImage || shareable?.dataset.shareableImage || '').trim();
  const videoProvider = String(group?.dataset.shareableVideoProvider || shareable?.dataset.shareableVideoProvider || '').trim();
  const videoId = String(group?.dataset.shareableVideoId || shareable?.dataset.shareableVideoId || '').trim();
  const videoUrl = String(group?.dataset.shareableVideoUrl || shareable?.dataset.shareableVideoUrl || '').trim();

  return {
    title,
    type,
    image,
    videoProvider,
    videoId,
    videoUrl
  };
}

function toSafeAbsoluteHttpUrl(url) {
  const absolute = toAbsoluteUrl(url || '');
  return toSafeHttpUrl(absolute);
}

// Video snippets are always rendered from these trusted, tightly-validated
// fields — never from a raw DOM/HTML snapshot. This is what makes the exact
// same renderer safe to reuse for both locally-saved and server-shared items.
const VIDEO_ID_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

// The real play/pause button, rendered server-side once via the site's own
// button/icon components (see evergreen-sidebar.twig) — reused verbatim here
// instead of recreating its markup or styling.
function getVideoControlHtml() {
  return document.getElementById('shareable-video-control-template')?.innerHTML || '';
}

const EMBED_URL_BUILDERS = {
  youtube: (id) => `https://www.youtube.com/embed/${id}?rel=0&autoplay=1`,
  vimeo: (id) => `https://player.vimeo.com/video/${id}?autoplay=1`,
};

function buildVideoEmbedHtml(item) {
  const provider = String(item.provider || '').trim();
  const thumbnail = toSafeAbsoluteHttpUrl(item.thumbnail);
  const posterMarkup = thumbnail
    ? `<img src="${escapeHtml(thumbnail)}" alt="${escapeHtml(item.title || '')}" />`
    : '';

  const buildEmbedUrl = EMBED_URL_BUILDERS[provider];
  if (buildEmbedUrl && VIDEO_ID_PATTERN.test(item.videoId || '')) {
    const embedUrl = buildEmbedUrl(item.videoId);
    return `<div class="video :autoplay-false saved-video__media" data-playing="false"><a class="overlink video__overlink" href="${embedUrl}">${posterMarkup}</a>${getVideoControlHtml()}</div>`;
  }

  if (provider === 'file') {
    const safeUrl = toSafeHttpUrl(item.videoUrl);
    if (safeUrl) {
      const posterAttr = thumbnail ? ` poster="${escapeHtml(thumbnail)}"` : '';
      return `<div class="saved-video__media"><video controls playsinline${posterAttr} src="${escapeHtml(safeUrl)}"></video></div>`;
    }
  }

  return '';
}

function buildTextFragmentUrl(pageUrl, text) {
  const cleanedText = String(text || '').trim().replace(/\s+/g, ' ');
  if (!cleanedText) return toAbsoluteUrl(pageUrl);

  const url = new URL(toAbsoluteUrl(pageUrl));
  url.hash = `:~:text=${encodeURIComponent(cleanedText)}`;
  return url.href;
}

function detectSnippetSharePlatform(linkEl, index) {
  const explicit = String(linkEl?.dataset?.snippetSharePlatform || '').trim().toLowerCase();
  if (explicit === 'x' || explicit === 'bluesky' || explicit === 'threads') {
    return explicit;
  }

  const label = String(linkEl?.textContent || '').trim().toLowerCase();
  if (label.includes('bluesky')) return 'bluesky';
  if (label.includes('thread')) return 'threads';
  if (label === 'x' || label.includes(' x ')) return 'x';

  const fallback = ['x', 'bluesky', 'threads'];
  return fallback[index] || '';
}

function updateSnippetShareIntentLinks(sourceText) {
  if (!snippetShareTrigger) return false;

  const panelId = snippetShareTrigger.getAttribute('aria-controls');
  if (!panelId) return false;

  const panel = document.getElementById(panelId);
  if (!panel) return false;

  const fragmentUrl = buildTextFragmentUrl(window.location.href, sourceText);
  const shareBody = `${sourceText}\n\n${fragmentUrl}`;
  const intents = {
    x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(fragmentUrl)}&text=${encodeURIComponent(sourceText)}`,
    bluesky: `https://bsky.app/intent/compose?text=${encodeURIComponent(shareBody)}`,
    threads: `https://www.threads.net/intent/post?text=${encodeURIComponent(shareBody)}`
  };

  const links = Array.from(
    panel.querySelectorAll(
      'a.social-anchor, .social-anchor-group a.social-anchor, [data-pattern="social-anchor"] a, .social-anchor-group a[href]'
    )
  );
  if (!links.length) return false;

  links.forEach((linkEl, index) => {
    const platform = detectSnippetSharePlatform(linkEl, index);
    const href = intents[platform];
    if (!href) return;

    linkEl.href = href;
    linkEl.target = '_blank';
    linkEl.rel = 'noopener noreferrer';
  });

  return true;
}

function selectionToMarkdown(selection) {
  if (!selection || selection.rangeCount < 1) return '';

  const range = selection.getRangeAt(0);
  const fragment = range.cloneContents();
  const blockTags = new Set(['p', 'div', 'section', 'article', 'blockquote', 'pre', 'ul', 'ol', 'li', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']);

  function renderNode(node) {
    if (!node) return '';

    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent || '';
    }

    if (node.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      return Array.from(node.childNodes).map(renderNode).join('');
    }

    if (node.nodeType !== Node.ELEMENT_NODE) {
      return '';
    }

    const tag = node.tagName.toLowerCase();

    if (tag === 'br') {
      return '\n';
    }

    if (tag === 'a') {
      const label = Array.from(node.childNodes).map(renderNode).join('').trim();
      const href = toSafeAbsoluteHttpUrl(node.getAttribute('href'));
      if (!href) return label;
      return label ? `[${label}](${href})` : `<${href}>`;
    }

    if (tag === 'img') {
      const src = toSafeAbsoluteHttpUrl(node.getAttribute('src'));
      if (!src) return '';
      const alt = String(node.getAttribute('alt') || 'image').trim();
      return `![${alt}](${src})`;
    }

    let content = Array.from(node.childNodes).map(renderNode).join('');
    if (tag === 'li') {
      content = `- ${content.trim()}\n`;
    }

    if (blockTags.has(tag)) {
      return `\n${content}\n`;
    }

    return content;
  }

  return renderNode(fragment)
    .replace(/\r/g, '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

function openSidebar() {
  sidebar?.classList.add('active');
}



window.showSidebarNotice = function (message, variant = 'success') {
  if (!message) return;

  let notice = document.querySelector('.evergreen-sidebar-notice');

  if (!notice) {
    notice = document.createElement('div');
    notice.className = 'evergreen-sidebar-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    document.body.appendChild(notice);
  }

  notice.textContent = String(message);
  notice.dataset.variant = variant;
  notice.classList.add('is-visible');

  if (noticeTimer) {
    window.clearTimeout(noticeTimer);
  }

  noticeTimer = window.setTimeout(() => {
    notice.classList.remove('is-visible');
  }, 2200);
};

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

async function copyToClipboard(text) {
  const normalized = String(text || '');
  if (!normalized) return;

  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(normalized);
    return;
  }

  const fallback = document.createElement('textarea');
  fallback.value = normalized;
  fallback.setAttribute('readonly', '');
  fallback.style.position = 'absolute';
  fallback.style.left = '-9999px';
  document.body.appendChild(fallback);
  fallback.select();
  document.execCommand('copy');
  fallback.remove();
}

async function postAjax(data) {
  const ajaxUrl = window.fritzScripts?.ajaxurl;
  if (!ajaxUrl) {
    throw new Error('Missing ajaxurl');
  }

  const body = new URLSearchParams(data).toString();
  const response = await fetch(ajaxUrl, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    body
  });

  if (!response.ok) {
    throw new Error(`AJAX request failed (${response.status})`);
  }

  return response.json();
}

function buildPrintableHtml(saved) {
  const logoMarkup = document.querySelector('.site-logo')?.outerHTML || `<h1>${escapeHtml(document.title || 'My Notes')}</h1>`;

  const listMarkup = saved
    .slice()
    .reverse()
    .map((item) => {
      const itemTitle = escapeHtml(item.title || 'Source page');
      const sourceUrl = toSafeHttpUrl(item.url);
      const sourceMarkup = sourceUrl
        ? `<p class="print-snippet__url"><strong>Source:</strong> ${escapeHtml(sourceUrl)}</p>`
        : '';

      if (item.type === 'image' && item.src) {
        const src = toSafeHttpUrl(item.src);
        if (!src) return '';

        return `
          <article class="print-snippet print-snippet--image">
            <p class="print-snippet__title">${itemTitle}</p>
            ${sourceMarkup}
            <p class="print-snippet__url"><strong>Image:</strong> ${escapeHtml(src)}</p>
            <img class="print-snippet__image" src="${escapeHtml(src)}" alt="${escapeHtml(item.alt || '')}" />
          </article>
        `;
      }

      if (item.type === 'video') {
        return `
          <article class="print-snippet">
            <p class="print-snippet__title">${itemTitle}</p>
            ${sourceMarkup}
          </article>
        `;
      }

      return `
        <article class="print-snippet">
          <p class="print-snippet__title">${itemTitle}</p>
          ${sourceMarkup}
          <p class="print-snippet__text">${escapeHtml(item.text || '')}</p>
        </article>
      `;
    })
    .join('');

  return `
    <header class="print-header">
      ${logoMarkup}
      <h2>Saved Notes</h2>
    </header>
    <section class="print-list">
      ${listMarkup}
    </section>
  `;
}

function buildPlainTextList(saved) {
  const lines = saved
    .slice()
    .reverse()
    .map((item) => {
      const title = String(item.title || 'Source page').trim();
      const sourceUrl = toSafeHttpUrl(item.url);
      const heading = sourceUrl ? `${title} (${sourceUrl})` : title;

      if (item.type === 'image' && item.src) {
        const imageUrl = toSafeHttpUrl(item.src);
        const alt = String(item.alt || '').trim();
        if (imageUrl && alt) {
          return `${heading}\nImage: ${imageUrl}\nAlt: ${alt}`;
        }
        if (imageUrl) {
          return `${heading}\nImage: ${imageUrl}`;
        }
        return heading;
      }

      if (item.type === 'video') {
        return heading;
      }

      const text = String(item.text || '').trim();
      return text ? `${heading}\n${text}` : heading;
    })
    .filter(Boolean);

  return lines.join('\n\n');
}

function printSavedList() {
  const saved = getSaved();
  if (!saved.length) {
    console.warn('[Snippet Saver] Cannot print an empty list.');
    showSidebarNotice('Nothing to print yet.', 'error');
    return;
  }

  let sheet = document.getElementById('evergreen-sidebar-print-sheet');
  if (!sheet) {
    sheet = document.createElement('section');
    sheet.id = 'evergreen-sidebar-print-sheet';
    document.body.appendChild(sheet);
  }

  sheet.innerHTML = buildPrintableHtml(saved);
  document.body.classList.add('is-printing-snippets');

  const cleanup = () => {
    document.body.classList.remove('is-printing-snippets');
    window.removeEventListener('afterprint', cleanup);
  };

  window.addEventListener('afterprint', cleanup);
  window.setTimeout(() => {
    window.print();
  }, 20);
}

async function createShareList() {
  const security = window.fritzScripts?.security || '';
  if (!security) {
    console.warn('[Snippet Saver] Cannot create share URL without nonce.');
    showSidebarNotice('Unable to share right now.', 'error');
    return;
  }

  const saved = getSaved();
  if (!saved.length) {
    console.warn('[Snippet Saver] Cannot share an empty list.');
    showSidebarNotice('Nothing to share yet.', 'error');
    return;
  }

  try {
    const payload = await postAjax({
      action: SHARE_ACTION_CREATE,
      security,
      snippets: JSON.stringify(saved)
    });

    const shareUrl = payload?.data?.url;
    if (!payload?.success || !shareUrl) {
      throw new Error('Invalid share response');
    }

    await copyToClipboard(shareUrl);
    console.log('[Snippet Saver] Share URL copied to clipboard:', shareUrl);
    showSidebarNotice('Share link copied.');
  } catch (error) {
    console.error('[Snippet Saver] Could not generate share URL.', error);
    showSidebarNotice('Could not create share link.', 'error');
  }
}

async function loadSharedListFromQuery() {
  const query = new URLSearchParams(window.location.search);
  const key = (query.get(SHARE_PARAM) || '').trim();

  if (!key) return;

  try {
    const payload = await postAjax({
      action: SHARE_ACTION_GET,
      key
    });

    if (!payload?.success || !Array.isArray(payload?.data?.snippets)) {
      throw new Error('Invalid shared list response');
    }

    setSaved(payload.data.snippets);
    renderSidebar();
    openSidebar();

    // Remove the share token from the URL after importing so reloads
    // do not overwrite any subsequent user edits to their local list.
    query.delete(SHARE_PARAM);
    const nextSearch = query.toString();
    const nextUrl = `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ''}${window.location.hash}`;
    window.history.replaceState({}, document.title, nextUrl);

    console.log('[Snippet Saver] Shared list imported from URL key:', key);
  } catch (error) {
    console.error('[Snippet Saver] Could not load shared list.', error);
  }
}

// -------------- Selection + Save (TEXT) --------------
// -------------- Selection + Save (TEXT) --------------
function hideSnippetTool() {
  if (saveContainer) {
    saveContainer.style.display = 'none';
  }
}

function selectionIsInsideMainContent(selectionObj) {
  if (!mainContent || !selectionObj || selectionObj.rangeCount < 1) return false;

  const range = selectionObj.getRangeAt(0);
  const container = range.commonAncestorContainer;
  const node = container.nodeType === Node.TEXT_NODE ? container.parentNode : container;

  return mainContent.contains(node);
}

let snippetToolVisible = false;
let lastSelectionText = '';

function handleSnippetSelection(e) {
  if (e && e.target.closest('#evergreen-sidebar-snippet-container')) {
    return;
  }

  const selectionObj = window.getSelection();
  const selection = selectionObj.toString().trim();

  console.log('[Snippet Saver] Selection change detected in #main-content. Selection:', selection);

  if (!selection.length || !selectionIsInsideMainContent(selectionObj)) {
    hideSnippetTool();
    snippetToolVisible = false;
    lastSelectionText = '';
    selectedTextMarkdown = '';
    console.log('[Snippet Saver] No valid text selected inside #main-content. Button hidden.');
    return;
  }

  selectedText = selection;
  selectedTextMarkdown = selectionToMarkdown(selectionObj) || selection;

  const isSameSelection = snippetToolVisible && lastSelectionText === selection;

  if (!isSameSelection && saveContainer) {
    // Mouse events anchor to the cursor; touch events (no `e`) anchor to the
    // lower-right corner instead, so the dialog doesn't collide with the
    // OS's native selection menu.
    if (e) {
      saveContainer.classList.remove('is-touch-position');
      saveContainer.style.top = `${e.pageY + 10}px`;
      saveContainer.style.left = `${e.pageX + 10}px`;
      console.log('[Snippet Saver] Save button positioned at:', e.pageX + 10, e.pageY + 10);
    } else {
      saveContainer.classList.add('is-touch-position');
      saveContainer.style.top = '';
      saveContainer.style.left = '';
    }
  }

  if (saveContainer) {
    saveContainer.style.display = 'block';
  }

  snippetToolVisible = true;
  lastSelectionText = selection;
}

if (mainContent && saveContainer) {
  mainContent.addEventListener('mouseup', handleSnippetSelection);

  // Mobile browsers don't reliably fire `mouseup` after a touch-based text
  // selection, so the save dialog needs its own touch trigger.
  mainContent.addEventListener('touchend', (e) => {
    if (e.target.closest('#evergreen-sidebar-snippet-container')) {
      return;
    }

    // Give the browser a moment to finalize the native selection after the
    // finger lifts — on touch devices the Selection API can lag a beat
    // behind touchend, especially when dragging the selection handles.
    setTimeout(() => handleSnippetSelection(null), 50);
  });
}

if (saveButton) {
  saveButton.addEventListener('click', () => {
    if (!selectedText) {
      console.warn('[Snippet Saver] No text to save.');
      return;
    }

    const pageTitle = document.querySelector('h1')?.innerText || document.title;
    const pageUrl = window.location.href;

    const saved = getSaved();
    saved.push({
      id: makeId(),
      type: 'text',
      title: pageTitle,
      url: pageUrl,
      text: selectedText,
      timestamp: Date.now()
    });
    setSaved(saved);

    console.log('[Snippet Saver] Text snippet saved. Total now:', saved.length);

    selectedText = '';
    selectedTextMarkdown = '';
    snippetToolVisible = false;
    lastSelectionText = '';
    if (saveContainer) saveContainer.style.display = 'none';
    renderSidebar();
    showSidebarNotice('Saved to My Notes');
  });
}

if (snippetCopyButton) {
  snippetCopyButton.addEventListener('click', async () => {
    const textToCopy = selectedTextMarkdown || selectedText || window.getSelection().toString().trim();

    if (!textToCopy) {
      console.warn('[Snippet Saver] No highlighted text to copy.');
      showSidebarNotice('No highlighted text to copy.', 'error');
      return;
    }

    try {
      await copyToClipboard(textToCopy);
      console.log('[Snippet Saver] Highlighted text copied.');
      showSidebarNotice('Selection copied.');
      selectedText = '';
      selectedTextMarkdown = '';
      snippetToolVisible = false;
      lastSelectionText = '';
      if (saveContainer) saveContainer.style.display = 'none';
    } catch (error) {
      console.error('[Snippet Saver] Could not copy highlighted text.', error);
      showSidebarNotice('Could not copy selection.', 'error');
    }
  });
}

if (snippetShareTrigger) {
  snippetShareTrigger.addEventListener('click', (e) => {
    const sourceText = (selectedText || window.getSelection().toString().trim()).trim();
    if (!sourceText) {
      e.preventDefault();
      showSidebarNotice('Highlight text to share.', 'error');
      return;
    }

    const updated = updateSnippetShareIntentLinks(sourceText);
    if (!updated) {
      showSidebarNotice('Could not build share links.', 'error');
    }
  });
}

if (shareButton) {
  shareButton.addEventListener('click', () => {
    createShareList();
  });
}

if (printButton) {
  printButton.addEventListener('click', () => {
    printSavedList();
  });
}

if (copyButton) {
  copyButton.addEventListener('click', async () => {
    const saved = getSaved();
    if (!saved.length) {
      console.warn('[Snippet Saver] Cannot copy an empty list.');
      showSidebarNotice('Nothing to copy yet.', 'error');
      return;
    }

    const textList = buildPlainTextList(saved);
    if (!textList) {
      console.warn('[Snippet Saver] No copyable content in list.');
      showSidebarNotice('No copyable notes found.', 'error');
      return;
    }

    try {
      await copyToClipboard(textList);
      console.log('[Snippet Saver] Plain-text notes list copied to clipboard.');
      showSidebarNotice('Notes copied.');
    } catch (error) {
      console.error('[Snippet Saver] Could not copy notes list.', error);
      showSidebarNotice('Copy failed.', 'error');
    }
  });
}

function isTouchDevice() {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
}

if (isTouchDevice()) {
  document.documentElement.classList.add('is-touch-device');
}

// -------------- Share/COPY URL from a shareable button group --------------
document.addEventListener('click', async (e) => {
  const shareBtn = e.target.closest('.evergreen-shareable .button-group #share');
  if (shareBtn) {
    e.preventDefault();
    const shareUrl = getShareableUrlFromElement(shareBtn);

    try {
      if (navigator.share) {
        await navigator.share({ url: shareUrl });
        showSidebarNotice('Share sheet opened.');
      } else {
        await copyToClipboard(shareUrl);
        showSidebarNotice('Shareable link copied.');
      }
      console.log('[Snippet Saver] Shareable URL shared:', shareUrl);
    } catch (error) {
      if (error?.name === 'AbortError') return;
      console.error('[Snippet Saver] Could not share URL.', error);
      showSidebarNotice('Could not share link.', 'error');
    }
    return;
  }

  const copyBtn = e.target.closest('.evergreen-shareable .button-group #copy');
  if (!copyBtn) return;

  e.preventDefault();
  const shareUrl = getShareableUrlFromElement(copyBtn);

  try {
    await copyToClipboard(shareUrl);
    showSidebarNotice('Shareable link copied.');
    console.log('[Snippet Saver] Shareable URL copied:', shareUrl);
  } catch (error) {
    console.error('[Snippet Saver] Could not copy shareable URL.', error);
    showSidebarNotice('Could not copy link.', 'error');
  }
});

// -------------- Save IMAGE via shareable’s #save --------------
document.addEventListener('click', (e) => {
  // NOTE: multiple #save buttons may exist inside .button-group within a shareable.
  const saveBtn = e.target.closest('.button-group #save');
  if (!saveBtn) return;

  e.preventDefault();

  const shareable = saveBtn.closest('.evergreen-shareable');
  if (!shareable) return;

  const img = shareable?.querySelector('img');
  const pageTitle = document.querySelector('h1')?.innerText || document.title;
  const pageUrl = getShareableUrlFromElement(saveBtn);
  const shareableMeta = getShareableMetaFromElement(saveBtn);
  const shareableTitle = shareableMeta.title || pageTitle;
  const shareableType = shareableMeta.type || (img ? 'image' : '');
  const saved = getSaved();

  if (shareableType === 'video' && shareableMeta.videoProvider) {
    const alreadySavedVideo = saved.some(
      (item) => item.type === 'video'
        && item.url === pageUrl
        && item.provider === shareableMeta.videoProvider
        && item.videoId === shareableMeta.videoId
        && item.videoUrl === shareableMeta.videoUrl
    );

    if (alreadySavedVideo) {
      console.log('[Snippet Saver] Video already saved for this page.');
      return;
    }

    saved.push({
      id: makeId(),
      type: 'video',
      title: shareableTitle,
      url: pageUrl,
      provider: shareableMeta.videoProvider,
      videoId: shareableMeta.videoId,
      videoUrl: shareableMeta.videoUrl,
      thumbnail: shareableMeta.image,
      timestamp: Date.now()
    });
    setSaved(saved);

    console.log('[Snippet Saver] Video saved. Total now:', saved.length);
    renderSidebar();
    return;
  }

  if (shareableType !== 'image' || !img) {
    const ogImageSrc = toSafeAbsoluteHttpUrl(shareableMeta.image);

    if (ogImageSrc) {
      const alreadySavedOg = saved.some(
        (item) => item.type === 'image' && item.src === ogImageSrc && item.url === pageUrl
      );

      if (alreadySavedOg) {
        console.log('[Snippet Saver] OG image already saved for this page.');
        return;
      }

      saved.push({
        id: makeId(),
        type: 'image',
        title: shareableTitle,
        url: pageUrl,
        src: ogImageSrc,
        alt: shareableTitle,
        width: null,
        height: null,
        timestamp: Date.now()
      });
      setSaved(saved);

      console.log('[Snippet Saver] No shareable image found, saved shareable OG image instead. Total now:', saved.length);
      renderSidebar();
      return;
    }

    const alreadySaved = saved.some(
      (item) => item.type === 'text' && item.url === pageUrl && item.title === shareableTitle && !item.text
    );

    if (alreadySaved) {
      console.log('[Snippet Saver] Shareable already saved for this page.');
      return;
    }

    saved.push({
      id: makeId(),
      type: 'text',
      title: shareableTitle,
      url: pageUrl,
      timestamp: Date.now()
    });
    setSaved(saved);

    console.log('[Snippet Saver] Shareable saved. Total now:', saved.length);
    renderSidebar();
    return;
  }

  const src = img.currentSrc || img.src;
  const absSrc = toAbsoluteUrl(src);

  const already = saved.some((s) => s.type === 'image' && s.src === absSrc && s.url === pageUrl);
  if (already) {
    console.log('[Snippet Saver] Image already saved for this page.');
    return;
  }

  saved.push({
    id: makeId(),
    type: 'image',
    title: shareableTitle,
    url: pageUrl,
    src: absSrc,
    alt: img.alt || '',
    width: img.naturalWidth || img.width || null,
    height: img.naturalHeight || img.height || null,
    timestamp: Date.now()
  });
  setSaved(saved);

  console.log('[Snippet Saver] Image saved. Total now:', saved.length);
  renderSidebar();
});

// -------------- Render Sidebar (text + image) --------------
function renderSidebar() {
  const container = document.getElementById('sidebar-content');
  if (!container) {
    console.warn('[Snippet Saver] Sidebar container not found.');
    return;
  }

  ensureIds();

  const saved = getSaved();
  console.log('[Snippet Saver] Rendering sidebar with', saved.length, 'snippets.');

  container.innerHTML = '';

  saved.slice().reverse().forEach((item) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('snippet');
    if (item.type === 'image') wrapper.classList.add('snippet--image');
    if (item.type === 'video') wrapper.classList.add('snippet--video');
    wrapper.dataset.id = item.id;

    // Content
    const contentDiv = document.createElement('div');
    contentDiv.classList.add('content');

    const videoEmbedHtml = item.type === 'video' ? buildVideoEmbedHtml(item) : '';
    const hasMedia = (item.type === 'image' && item.src) || (item.type === 'video' && videoEmbedHtml);

    if (!hasMedia) {
      const title = document.createElement('p');
      title.classList.add('title');
      const titleLink = document.createElement('a');
      titleLink.target = '_blank';
      titleLink.rel = 'noopener noreferrer';
      titleLink.textContent = item.title || 'Source page';
      titleLink.href = toSafeHttpUrl(item.url) || '#';
      title.appendChild(titleLink);
      contentDiv.appendChild(title);
    }

    if (item.type === 'image' && item.src) {
      const imgWrap = document.createElement('div');
      imgWrap.classList.add('saved-image');

      const imgEl = document.createElement('img');
      imgEl.src = item.src;
      if (item.alt) imgEl.alt = item.alt;

      imgWrap.appendChild(imgEl);
      contentDiv.appendChild(imgWrap);
    } else if (item.type === 'video' && videoEmbedHtml) {
      const videoWrap = document.createElement('div');
      videoWrap.classList.add('saved-video');
      videoWrap.innerHTML = videoEmbedHtml;

      contentDiv.appendChild(videoWrap);
    } else if (item.text) {
      const text = document.createElement('p');
      text.textContent = item.text || '';
      contentDiv.appendChild(text);
    }

    const closeDiv = document.createElement('div');
    closeDiv.classList.add('close');
    closeDiv.setAttribute('aria-label', 'Remove snippet');
    closeDiv.title = 'Remove snippet';
    closeDiv.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none" aria-hidden="true" focusable="false">
        <path d="M17.1934 4.27686L11.5957 9.87451L17.1934 15.4722L16.0146 16.6509L10.417 11.0532L4.81934 16.6509L3.64062 15.4722L9.23828 9.87451L3.64062 4.27686L4.81934 3.09814L10.417 8.6958L16.0146 3.09814L17.1934 4.27686Z" fill="#072012"/>
      </svg>
    `;

    wrapper.appendChild(closeDiv);
    wrapper.appendChild(contentDiv);
    container.appendChild(wrapper);
  });

  const clearBtn = document.querySelector('#evergreen-sidebar-clear');
  if (clearBtn) {
    clearBtn.onclick = () => {
      localStorage.removeItem('savedSnippets');
      console.log('[Snippet Saver] All snippets cleared.');
      renderSidebar();
    };
  }
  updateSavedCount();
}

// -------------- Play saved-video embeds on click --------------
document.addEventListener('click', (e) => {
  // The real .video__control/.playback-toggle button is a sibling of the
  // overlink, not a descendant of it, so a click on the button never bubbles
  // through .video__overlink — it has to be matched here too.
  const trigger = e.target.closest('#sidebar-content .video__overlink, #sidebar-content .saved-video__media .playback-toggle');
  if (!trigger) return;

  const container = trigger.closest('.saved-video__media');
  if (!container) return;

  const overlink = container.querySelector('.video__overlink');
  if (!overlink) return;

  e.preventDefault();
  // Both this listener and the "close sidebar on outside click" listener are
  // bound to `document`, and the latter walks up from e.target — which we're
  // about to detach below. stopImmediatePropagation is required (not just
  // stopPropagation) to stop that later same-node listener from also running.
  e.stopImmediatePropagation();

  const iframe = document.createElement('iframe');
  iframe.src = overlink.getAttribute('href') || '';
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; fullscreen; picture-in-picture');
  iframe.setAttribute('allowfullscreen', 'true');

  container.querySelectorAll(':scope > *').forEach((el) => el.remove());
  container.appendChild(iframe);
});

// -------------- One-time binds on DOM ready --------------
document.addEventListener('DOMContentLoaded', () => {
  console.log('[Snippet Saver] DOM loaded. Rendering sidebar.');
  renderSidebar();
  if (sidebar) loadSharedListFromQuery();

  // Close (remove) via event delegation—bind once
  const container = document.getElementById('sidebar-content');
  if (container && !container.dataset.closeBound) {
    container.addEventListener('click', (e) => {
      const close = e.target.closest('.close');
      if (!close) return;

      const snippetEl = close.closest('.snippet');
      if (!snippetEl) return;

      const id = snippetEl.dataset.id;
      if (!id) {
        console.warn('[Snippet Saver] Could not determine which snippet to remove (missing data-id).');
        return;
      }

      const saved = getSaved();
      const next = saved.filter((s) => s.id !== id);
      setSaved(next);

      console.log('[Snippet Saver] Removed one snippet. Total now:', next.length);
      renderSidebar();
    });

    container.dataset.closeBound = '1';
  }

  // Sidebar toggle(s)
  sidebarToggleButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      e.stopPropagation();
      sidebar?.classList.toggle('active');
    });
  });

  // Close sidebar when clicking outside
  document.addEventListener('click', (e) => {
    if (!sidebar?.classList.contains('active')) return;

    const clickedInsideSidebar = e.target.closest('.evergreen-sidebar-container');
    const clickedToggle = e.target.closest('#sidebar-toggle');

    if (!clickedInsideSidebar && !clickedToggle) {
      sidebar.classList.remove('active');
    }
  });
});
